import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import {
  dictionaryService,
  projectService,
  userService,
} from "../../../services/api";
import "../../../styles/UserProfile.css"; // Réutilise le même CSS pour la cohérence

const MesContrib = () => {
  const { currentUser, logout } = useContext(AuthContext);
  const [entries, setEntries] = useState([]);
  const [projects, setProjects] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (currentUser) {
      const params = { created_by: currentUser.id, page: 1 };
      dictionaryService
        .getAllEntries(params)
        .then((res) => setEntries(res.data.results))
        .catch(() => setError("Erreur lors du chargement des  entries."));
      projectService
        .getAllProjects(params)
        .then((res) => setProjects(res.data.results))
        .catch(() => setError("Erreur lors du chargement des projets."));
    }
  }, [currentUser]);

  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    window.location.href = "/connexion";
  };

  // Gestion du menu paramètres (affichage du sous-menu)
  useEffect(() => {
    const toggle = document.getElementById("settings-toggle");
    const submenu = document.getElementById("settings-submenu");
    if (toggle && submenu) {
      toggle.onclick = (e) => {
        e.preventDefault();
        submenu.style.display =
          submenu.style.display === "flex" ? "none" : "flex";
      };
    }
    return () => {
      if (toggle) toggle.onclick = null;
    };
  }, []);

  if (!currentUser) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            background: "rgba(255,255,255,0.9)",
            border: "none",
            borderRadius: "15px",
            padding: "20px",
            color: "#856404",
          }}
        >
          Vous devez être connecté pour voir vos entries.
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        background: "#f0f2f5",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      {/* Sidebar */}
      {/* <div
        style={{
          width: "320px",
          background:
            "linear-gradient(180deg,rgb(114, 160, 206) 0%,rgb(234, 239, 244) 100%)",
          boxShadow: "4px 0 20px rgba(0,0,0,0.1)",
          position: "fixed",
          height: "100vh",
          left: 0,
          top: 0,
          zIndex: 1000,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            padding: "20px 30px",
            textAlign: "center",
            borderBottom: "1px solid rgba(58, 162, 242, 0.1)",
            background:
              "linear-gradient(135deg, rgba(225, 236, 241, 0.1) 0%, rgba(233, 231, 231, 0.05) 100%)",
          }}
        >
          <div
            style={{
              width: "120px",
              height: "120px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              margin: "0 auto 20px auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "48px",
              color: "white",
              fontWeight: "bold",
              boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {currentUser.profile_image ? (
              <img
                src={currentUser.profile_image}
                alt="Photo de profil"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            ) : (
              <span>{`${currentUser.first_name?.[0] || ""}${
                currentUser.last_name?.[0] || ""
              }`}</span>
            )}
          </div>
          <h4
            style={{ color: "white", margin: "0 0 8px 0", fontWeight: "600" }}
          >
            {`${currentUser.first_name} ${currentUser.last_name}`}
          </h4>
          <p
            style={{
              color: "rgba(11, 11, 11, 0.7)",
              margin: "0 0 15px 0",
              fontSize: "14px",
            }}
          >
            {currentUser.email}
          </p>
        </div>
        {/* Navigation */}
      {/*
        <div style={{ flex: 1, padding: "20px 8px" }}>
          <nav>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              <li>
                <a
                  href="/profil"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "15px 30px",
                    color: "rgba(11, 7, 7, 0.7)",
                    textDecoration: "none",
                    fontSize: "15px",
                    fontWeight: "400",
                  }}
                >
                  <span
                    role="img"
                    aria-label="profil"
                    style={{ marginRight: 10 }}
                  >
                    👤
                  </span>
                  Mon Profil
                </a>
              </li>
              <li>
                <a
                  href="/mes entries"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "15px 30px",
                    color: "#667eea",
                    background: "rgba(255,255,255,0.1)",
                    textDecoration: "none",
                    borderRight: "4px solid #667eea",
                    fontWeight: "600",
                    fontSize: "15px",
                  }}
                >
                  <span
                    role="img"
                    aria-label=" entries"
                    style={{ marginRight: 10 }}
                  >
                    ✏️
                  </span>
                  Mes  entries
                </a>
              </li>
              <li>
                <a
                  href="/historique"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "15px 30px",
                    color: "rgba(11, 7, 7, 0.7)",
                    textDecoration: "none",
                    fontSize: "15px",
                    fontWeight: "400",
                  }}
                >
                  <span
                    role="img"
                    aria-label="historique"
                    style={{ marginRight: 10 }}
                  >
                    🕒
                  </span>
                  Historique
                </a>
              </li>
              <li>
               
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <a
                    href="#"
                    id="settings-toggle"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "15px 30px",
                      color: "rgba(11, 7, 7, 0.7)",
                      textDecoration: "none",
                      fontSize: "15px",
                      fontWeight: "400",
                    }}
                  >
                    <span
                      role="img"
                      aria-label="settings"
                      style={{ marginRight: 10 }}
                    >
                      ⚙️
                    </span>
                    Paramètres
                    <span style={{ marginLeft: "auto" }}>▼</span>
                  </a>
                  <div
                    className="submenu"
                    id="settings-submenu"
                    style={{
                      display: "none",
                      flexDirection: "column",
                      paddingLeft: 20,
                      marginTop: 5,
                    }}
                  >
                    <a
                      href="#"
                      style={{
                        fontSize: 14,
                        padding: "8px 12px",
                        color: "#444",
                      }}
                    >
                      <i
                        className="fas fa-shield-alt"
                        style={{ marginRight: 8 }}
                      ></i>
                      Confidentialité
                    </a>
                    <a
                      href="/notifications"
                      style={{
                        fontSize: 14,
                        padding: "8px 12px",
                        color: "#444",
                      }}
                    >
                      <i className="fas fa-bell" style={{ marginRight: 8 }}></i>
                      Notifications
                    </a>
                    <a
                      href="/aide"
                      style={{
                        fontSize: 14,
                        padding: "8px 12px",
                        color: "#444",
                      }}
                    >
                      <i
                        className="fas fa-question-circle"
                        style={{ marginRight: 8 }}
                      ></i>
                      Aide
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </nav>
        </div>
        <div
          style={{
            padding: "20px 30px",
            borderTop: "1px solid rgba(255,255,255,0.1)",
          }}
        >
          <a
            href="#"
            onClick={handleLogout}
            style={{
              width: "100%",
              background: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
              color: "white",
              border: "none",
              padding: "12px 20px",
              borderRadius: "12px",
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
              textAlign: "center",
              display: "block",
              textDecoration: "none",
            }}
          >
            Déconnexion
          </a>
        </div>
      </div> */}

      {/* Main content */}
      <div
        style={{
          marginLeft: "320px",
          flex: 1,
          padding: "40px",
          minHeight: "100vh",
        }}
      >
        <div
          style={{
            background: "white",
            borderRadius: "16px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
            padding: "30px",
            maxWidth: "1000px",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              width: "60%",
              marginBottom: "30px",
              backgroundColor: "white",
              borderRadius: "25px",
              padding: "10px 20px",
              display: "flex",
              alignItems: "center",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <input
              type="text"
              placeholder="Rechercher..."
              style={{
                border: "none",
                outline: "none",
                width: "100%",
                fontSize: "16px",
                background: "transparent",
              }}
            />
          </div>
          <h2
            style={{ fontSize: "24px", marginBottom: "25px", color: "#435086" }}
          >
            Mes entries
          </h2>
          {error && (
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "20px",
                marginTop: "20px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                borderLeft: "6px solid #e74c3c",
              }}
            >
              <p style={{ color: "#c0392b" }}>{error}</p>
            </div>
          )}
          {entries.length === 0 && !error && (
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "20px",
                marginTop: "20px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                borderLeft: "6px solid #435086",
              }}
            >
              <p>Aucune contribution pour le moment.</p>
            </div>
          )}
          {entries.map((contrib, idx) => (
            <div
              key={idx}
              style={{
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "20px",
                marginTop: "20px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                borderLeft: "6px solid #435086",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <h3 style={{ fontSize: "18px", color: "black", margin: 0 }}>
                  Ajout du mot :{" "}
                  <span style={{ fontWeight: 600, color: "#2c2c2c" }}>
                    {contrib.word}
                  </span>
                </h3>
                <span
                  style={{
                    fontSize: "14px",
                    color: "#888",
                    fontStyle: "italic",
                  }}
                >
                  {new Date(contrib.created_at).toLocaleDateString("fr-FR", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  })}
                </span>
              </div>

              <p style={{ fontSize: "14px", color: "#333", marginTop: 6 }}>
                <strong>{contrib.status}</strong>
              </p>
            </div>
          ))}
          {/* projects */}
          {projects.length === 0 && !error && (
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "20px",
                marginTop: "20px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                borderLeft: "6px solid #435086",
              }}
            >
              <p>Aucune project pour le moment.</p>
            </div>
          )}
          {projects.map((project, idx) => (
            <div
              key={idx}
              style={{
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "20px",
                marginTop: "20px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                borderLeft: "6px solid #435086",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <h3 style={{ fontSize: "18px", color: "black", margin: 0 }}>
                  Ajout project :{" "}
                  <span style={{ fontWeight: 600, color: "#2c2c2c" }}>
                    {project.title}
                  </span>
                </h3>
                <span
                  style={{
                    fontSize: "14px",
                    color: "#888",
                    fontStyle: "italic",
                  }}
                >
                  {new Date(project.created_at).toLocaleDateString("fr-FR", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  })}
                </span>
              </div>

              {/* projects */}
              <p style={{ fontSize: "14px", color: "#333", marginTop: 6 }}>
                <strong>{project.status}</strong>
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MesContrib;
